/**
 * PreferencesIcon — icône "réglages du jour" custom MyTenue.
 *
 * Style sliders (3 curseurs horizontaux) — symbolise le réglage fin
 * des préférences (style, occasion, budget). Plus élégant que le
 * traditionnel ⚙️ et plus en phase avec l'identité premium MyTenue.
 *
 * v1.12.214
 */

import React from 'react';
import Svg, { Line, Circle } from 'react-native-svg';

export default function PreferencesIcon({ size = 22, color = '#1A1A1A', accent = '#D4AF72' }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* 3 rails horizontaux */}
      <Line x1="3" y1="7"  x2="21" y2="7"  stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <Line x1="3" y1="12" x2="21" y2="12" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <Line x1="3" y1="17" x2="21" y2="17" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      {/* 3 curseurs (positions différentes pour effet "réglage") */}
      <Circle cx="9"  cy="7"  r="2.6" fill="#FFFFFF" stroke={accent} strokeWidth="1.6" />
      <Circle cx="16" cy="12" r="2.6" fill="#FFFFFF" stroke={accent} strokeWidth="1.6" />
      <Circle cx="7"  cy="17" r="2.6" fill="#FFFFFF" stroke={accent} strokeWidth="1.6" />
    </Svg>
  );
}
